window.LabelMappingDict = {
	"eng": {
		"Purchase_workshop": "Purchase",
		"Good Receive": "",
		"Save Quantity": "",
		"Home": "",
		"Kiosk Home": "",
		"Purchase": "",
		"Supplier Price Inquiry": "",
		"PR Confirmation Search": "",
		"PR Confirmation": "",
		"PO Search": "",
		"Purchase Order": "",
		"Supplier Invoice Search": "",
		"Supplier Invoice Entry": "",
		"Sales": "",
		"Customer Quotation Search": "",
		"Customer Quotation Entry": "",
		"Customer PO Search": "",
		"Customer PO": "",
		"Delivery Note Search": "",
		"Delivery Note Entry": "",
		"Customer Invoice Search": "",
		"Customer Invoice": "",
		"Sales Return Search": "",
		"Sales Return": "",
		"Stock": "",
		"Stock Search": "",
		"Stock Take Search": "",
		"Stock Take": "",
		"Stock Transfer Search": "",
		"Stock Transfer": "",
		"Stock Adjustment": "",
		"Stock Adjustment Search": "",
		"Report": "",
		"Product Sales": "",
		"Stock Listing": "",
		"Stock Movement": "",
		"PO List": "",
		"Customer Quotation List": "",
		"Customer PO List": "",
		"POS Transaction": "",
		"Stock List": "",
		"Stock Movement List": "",
		"Inventory Variation": "",
		"Master": "",
		"PR Template": "",
		"BOM Search": "",
		"BOM Entry": "",
		"BOM Entry (Shop)": "",
		"BOM Template": "",
		"Product Master": "",
		"Unit Master": "",
		"User Role": "",
		"User Location": "",
		"Nutrition Master": "",
		"Logout": "",
		"User Preference": "",
		"Dashboard": "",
		"Refresh Frequency": "",
		"Refresh": "",
		"Location": "",
		"Supplier Code": "",
		"Product Code From": "",
		"Stock In No.": "",
		"Stock In Date": "",
		"Expiry Date": "",
		"Reset": "",
		"Location/Bin": "",
		"Product": "",
		"On-hand Balance": "",
		"Base Amount": "",
		"View Stock Details": "",
		"Stock Ledger": "",
		"Doc Date": "",
		"Post Date": "",
		"Doc No": "",
		"Stock ID": "",
		"In/Out Qty": "",
		"Close": "",
		"Supplier Reference No": "",
		"Product Remark": "",
		"Kiosk Home (Product Line)": "",
		"Login Home Page": "",
		"LOGIN": "",
		"Sign In to your account": "",
		"User Name": "",
		"Password": "",
		"Login": "",
		"Forgot password?": "",
		"Sign Up": "",
		"Register Now": "",
		"Procurement Dashboard": "",
		"Supplier Price List Not Updated": "",
		"Products": "",
		"Suppliers": "",
		"No. of shop Not Submitted PR": "",
		"Shops": "",
		"Department": "",
		"Contact Person": "",
		"Tel. No.": "",
		"Abnormal Product Quantity": "",
		"PR No": "",
		"Require Quantity": "",
		"Quantity Unit": "",
		"Base Unit": "",
		"Average Quantity": "",
		"Percentage": "",
		"New Product Requests": "",
		"PR Not Confirmed": "",
		"Receive Date": "",
		"Batch Confirm": "",
		"Pivot Table": "",
		"Total": "",
		"Total Amount": "",
		"Template Name": "",
		"Save as Template": "",
		"PR Not Generated PO": "",
		"Daily Genearted PO": "",
		"Today": "",
		"Yesterday": "",
		"Delivery Date": "",
		"Total Amount of PO in Last 7 days": "",
		"Top 10 Suppliers in Last 7 days": "",
		"Import": "",
		"Export": "",
		"Workshop Dashboard": "",
		"Workshop Dashboard (Manager)": "",
		"Not Enough Inventory": "",
		"Semi Product": "",
		"DN Quantity": "",
		"Product Balance": "",
		"Unit": "",
		"Generate": "",
		"Outstanding DN": "",
		"Outstanding": "",
		"Posted": "",
		"Date": "",
		"Location Group": "",
		"All": "",
		"No Location Group": "",
		"DN No": "",
		"DN Date": "",
		"To Location": "",
		"Delivery Type": "",
		"Below Minimum Stock Level": "",
		"Min Stock Level": "",
		"BOM Reserve": "",
		"DN Deliver": "",
		"GRN Receive": "",
		"Balance": "",
		"Above Maximum Stock Level": "",
		"Max Stock Level": "",
		"Not Match Quantity (DN & GRN)": "",
		"Records": "",
		"DNNo": "",
		"GRNNo": "",
		"ReceQuantity": "",
		"AdjustReceQuantity": "",
		"DNQuantity": "",
		"AdjustDNQuantity": "",
		"Stock in Quantity": "",
		"Adjust Stock in Quantity": "",
		"Stock out Quantity": "",
		"Adjust Stock out Quantity": "",
		"Each PR": "",
		"Group PR": "",
		"Daily Generated PO": "",
		"PO No": "",
		"PO Date": "",
		"Delivery Location": "",
		"Supplier": "",
		"Outstanding GRN": "",
		"Outstanding BOM": "",
		"Transaction Code": "",
		"Transaction Date": "",
		"Plan Quantity": "",
		"Processing BOM": "",
		"Batch Post": "",
		"Completed BOM": "",
		"Total Number of DN in Last 7 days": "",
		"Total Number and Amount of DN By Shop in Last 7 days (By Percentage)": "",
		"Please select": "",
		"PO Date From": "",
		"Request Date From": "",
		"Date From": "",
		"Delivery Date From": "",
		"Supplier Invoice No. From": "",
		"PO Number": "",
		"Search": "",
		"PO Type": "",
		"PO Status": "",
		"Purchase Type": "",
		"Consignment Contract": "",
		"Consignment Purchase": "",
		"Normal Purchase": "",
		"Incharge": "",
		"Currency": "",
		"Exchange Rate": "",
		"Mark Product": "",
		"Product Code": "",
		"Supplier Reference No.": "",
		"Dimension": "",
		"Dimension Description": "",
		"Quantity": "",
		"Keep Inventory": "",
		"No": "",
		"Yes": "",
		"Unit price": "",
		"Discount %": "",
		"Net Unit Price": "",
		"Location Type": "",
		"Product Line": "",
		"Target Date": "",
		"Search ": "",
		"Tax code": "",
		"Amount": "",
		"Remark": "",
		"Save": "",
		"Cancel": "",
		"Reference No.": "",
		"Placing Orderd Method": "",
		"Wechat": "",
		"Nil": "",
		"Whatsapp": "",
		"Payment terms": "",
		"Payment method": "",
		"80/20 80% downpayment, 20% balance": "",
		"Contact person": "",
		"Contact person title": "",
		"Office Phone No.": "",
		"Mobile Phone No.": "",
		"Fax": "",
		"Email": "",
		"Address": "",
		"Delivery": "",
		"Contact Person Title": "",
		"Offic Phone No.": "",
		"Avaliable Good Receive Time": "",
		"Remarks": "",
		"Remark 1": "",
		"Remark 2": "",
		"Remark 3": "",
		"Attachment": "",
		"Delivery Note": "",
		"Delivery Note No.": "",
		"Source Type": "",
		"Customer Order": "",
		"Mark Purchase Order": "",
		"Mark Customer Order": "",
		"PO No. From": "",
		"Customer Code": "",
		"Delivery Type Code": "",
		"To Department": "",
		"Delivery quantity": "",
		"Delivery Address": "",
		"Delivery Contact Person": "",
		"Delivery Contact Person Title": "",
		"Delivery Office Phone No.": "",
		"Delivery Mobile Phone No.": "",
		"Delivery Fax": "",
		"Delivery Email": "",
		"Delivery Remark": "",
		"Print": "",
		"Submit": "",
		"Template Code": "",
		"Delivery Time Session": "",
		"Quanity Unit": "",
		"Default Supplier": "",
		"Own Supplier": "",
		"Apply Daily": "",
		"Edit Product Details": "",
		"Product Tag": "",
		"Select Product Tag": "",
		"No ": "",
		"Default Supplier Code": "",
		"Save ": "",
		"Delete": "",
		"BOM No From": "",
		"BOM Date From": "",
		"Finished Product": "",
		"Post Status": "",
		"Confirmed": "",
		"Pending": "",
		"BOM No": "",
		"BOM Date": "",
		"Type": "",
		"Finished Good": "",
		"Bin": "",
		"BOM Dimension Form": "",
		"Actual Quantity": "",
		"Nutrient Code": "",
		"Serving Size": "",
		"Servings Per Package": "",
		"Raw Material": "",
		"Recalculate": "",
		"Wastage%": "",
		"Cal Usage": "",
		"Edit Raw Material Detail": "",
		"Standard Quantity": "",
		"Recipe Group": "",
		"Major Group": "",
		"Gross Weight": "",
		"Charge": "",
		"Active Status": "",
		"Active": "",
		"Draft": "",
		"Inactive": "",
		"Inventory Details": "",
		"Description": "",
		"Other Description": "",
		"Specification": "",
		"Barcode": "",
		"Product Type": "",
		"Product Group": "",
		"Product Category 1": "",
		"Product Category 2": "",
		"Product Category 3": "",
		"Product Category 4": "",
		"Product Category 5": "",
		"Product Group Type": "",
		"Inventory": "",
		"Stock Type": "",
		"Expense": "",
		"Fixed Asset": "",
		"Service": "",
		"Costing Method": "",
		"Keep Base Unit 2": "",
		"Expire in X days": "",
		"Expire Days": "",
		"Minimum Stock Level": "",
		"Maximum Stock Level": "",
		"Product Price": "",
		"Select lowest price off": "",
		"Purchase Tax Code": "",
		"Sales Tax Code": "",
		"Default Price": "",
		"Account Code": "",
		"Country of origin": "",
		"Product Dimension": "",
		"Description1": "",
		"Description2": "",
		"Description3": "",
		"Ingredient": "",
		"Origin": "",
		"Ingredient Description 1": "",
		"Ingredient Description 2": "",
		"Nutrition": "",
		"Nutrition Information Display Format": "",
		"Image": "",
		"Unit Code": "",
		"Name": "",
		"Convert Unit": "",
		"Convert Rate": "",
		"System Admin": "",
		"Procurement": "",
		"Shop Manager": "",
		"Workshop": "",
		"User": "",
		"Function Description": "",
		"BOM Entry (Product Line View)": "",
		"Customer Quotation": "",
		"DN Adjust Quantity": "",
		"Kiosk (GRN & PR Application)": "",
		"OS List": "",
		"PO Generation": "",
		"Product Master ": "",
		"User Code": "",
		"User Type": "",
		"Location Code": "",
		"Default Location": "",
		"Display Format": "",
		"Nutrient": "",
		"Nutrition Group": "",
		"Sub Group": "",
		"QTY": "",
		"% Chinese NRV per serving": "",
		"Stock Take No. From": "",
		"Count Sheet Date From": "",
		"Stock Take Date From": "",
		"Stock Take No.": "",
		"Count Sheet Date": "",
		"Stock Take Date": "",
		"Export Count Sheet": "",
		"Import Stock Take": "",
		"Count Sheet Quantity": "",
		"Stock Take Quantity": "",
		"PR No.": "",
		"GRN No.": "",
		"PO No.": "",
		"Description 1": "",
		"Description 2": "",
		"Description 3": "",
		"UD Field 1": "",
		"UD Field 2": "",
		"UD Field 3": "",
		"UD Field 4": "",
		"Barcode No.": "",
		"Document No. From": "",
		"From Location": "",
		"Document No.": "",
		"Import Stock": "",
		"Reason": "",
		"From Bin": "",
		"From PR No": "",
		"To Bin": "",
		"To PR No": "",
		"UDField 1": "",
		"UDField 2": "",
		"UDField 3": "",
		"UDField 4": "",
		"Unit Price": "",
		"Gen Barcode No.": "",
		"Stock Adjust No.": "",
		"Transaction Type": "",
		"Reference Document No": "",
		"Adjustment Date": "",
		"Adjust Quantity": "",
		"Stock Adjust No. From": "",
		"Adjustment Date From": "",
		"Start Date": "",
		"End Date": "",
		"Discount(%)": "",
		"PR Code From": "",
		"Receive Date From": "",
		"Confirm Status": "",
		"PRNo": "",
		"PR Number": "",
		"Have Substitution": "",
		"General": "",
		"PR Type": "",
		"Purpose": "",
		"Total Amonut": "",
		"Region": "",
		"Title": "",
		"Fax No.": "",
		"Request Quantity": "",
		"PR Confirm Product Dimension Form": "",
		"Minimum Order Quantity": "",
		"Supplier Reference Code": "",
		"Currency Code": "",
		"Discount%": "",
		"Purchase Unit": "",
		"Substitution": "",
		"Confirm": "",
		"PR No From": "",
		"Generate PO By": "",
		"Batch No": "",
		"Batch No.": "",
		"Supplier Address": "",
		"Create User": "",
		"Consignement Contract": "",
		"Consignement Purchase": "",
		"Exchange rate": "",
		"Placing Orders Method": "",
		"Payment Terms": "",
		"Payment Method": "",
		"Available Good Receive Time": "",
		"Supplier Invoice ": "",
		"Internal No From": "",
		"Invoice No From": "",
		"Invoice Date From": "",
		"Receive Location": "",
		"Internal No": "",
		"Supplier Invoice No": "",
		"Supplier Invoice Date": "",
		"Previous": "",
		"Next": "",
		"Page": "",
		"Supplier Invoice": "",
		"Supplier Invoice No.": "",
		"GRN Issued": "",
		"Both billing and received": "",
		"Billing for received item only": "",
		"Receive Department": "",
		"Supplier Ref No": "",
		"Billing Type": "",
		"With Product": "",
		"With Payment Method": "",
		"80/20 80% Downpayment, 20% Balance": "",
		"Supplier Contact Person": "",
		"Supplier Contact Person Title": "",
		"Supplier Office Phone No": "",
		"Supplier Mobile Phone No": "",
		"Supplier Fax": "",
		"Supplier Email": "",
		"Account Analysis": "",
		"Analysis Code 1": "",
		"AnaCode1": "",
		"Analysis Code 2": "",
		"AnaCode2": "",
		"Analysis Code 3": "",
		"AnaCode3": "",
		"Analysis Code 4": "",
		"AnaCode4": "",
		"Analysis Code 5": "",
		"AnaCode5": "",
		"Product Sales Search": "",
		"Product Group From": "",
		"Product Type From": "",
		"Location From": "",
		"Supplier Code From": "",
		"Issue Date From": "",
		"Product Line From": "",
		"Stock Listing Search": "",
		"Unit of Quantity": "",
		"Period From": "",
		"S. PKG No.": "",
		"Product List": "",
		"Product Search": "",
		"Product List Report": "",
		"PR Summary Report": "",
		"Location Code From": "",
		"PR/PO Status Report": "",
		"PRNo From": "",
		"To": "",
		"PRDate From": "",
		"Delivery Schedule (By Shipping Date) Report": "",
		"Supplier Ref. No. From": "",
		"Complete Status": "",
		"Transfer Search": "",
		"Stock Transfer Report": "",
		"Transfer Date From": "",
		"Stock Balance Report": "",
		"Detail Balance Report": "",
		"Detail Balance": "",
		"Monthly In Out Report": "",
		"Period": "",
		"Monthly In Out": "",
		"Stock Aging Report": "",
		"Cut Off Date": "",
		"Stock Aging": "",
		"Stock Movement Search": "",
		"Doc No.": "",
		"Stock Movement Report": "",
		"GRN Status": "",
		"GRN Status Report": "",
		"GRN No. From": "",
		"GRN Date From": "",
		"Recipe Cost Report": "",
		"BOM Cost Report": "",
		"Quotation No. From": "",
		"Quotation Date From": "",
		"Quotation No.": "",
		"Quotation Date": "",
		"Default Values": "",
		"Lead Time (Days)": "",
		"Default Lead Time": "",
		"Default Discount %": "",
		"Price Unit": "",
		"Customer": "",
		"Customer Address": "",
		"Customer Purchase Order": "",
		"Mark Quotation": "",
		"Mark Customer Quotation": "",
		"PO Status ": "",
		"Customer Reference No.": "",
		"Customer Purchase Order Product Dimension": "",
		"Discount Percentage": "",
		"Customer Price Inquiry": "",
		"Tax Code": "",
		"Remark ": "",
		"Delivery Note No. From": "",
		"DN Date From": "",
		"Status": "",
		"Reference No. From": "",
		"Delivery Quantity": "",
		"Invoice No. From": "",
		"Customer Invoice No": "",
		"Customer Invoice Date": "",
		"Customer Invoice No.": "",
		"DN Issued": "",
		"Both Billing and delivery": "",
		"Consignment invoice": "",
		"Billing for delivered item only": "",
		"Mark Delivery Note": "",
		"DN No From": "",
		"Delivery Department": "",
		"Customer Ref No.": "",
		"Customer Contact Person": "",
		"Customer Contact Person Title": "",
		"Customer Office Phone No.": "",
		"Customer Mobile Phone No.": "",
		"Customer Fax": "",
		"Customer Email": "",
		"Analysis Code 1 ": "",
		"Sales Return No. From": "",
		"SR Date From": "",
		"Sales Return No.": "",
		"Customer Ref. No.": "",
		"Weekly Forecast": "",
		"Sunday": "",
		"Monday": "",
		"Tuesday": "",
		"Wednesday": "",
		"Thursday": "",
		"Friday": "",
		"Saturday": "",
		"Shrinkage": "",
		"Shrinkage List": "",
		"Shrinkage Form": "",
		"Balance B/F": "",
		"Expect Inventory": "",
		"Wastage": "",
		"Product Line Dashboard": "",
		"Target Quantity": "",
		"Stock Inquiry": "",
		"Stock Report": "",
		"Generate Data Grid": "",
		"Generate Report": "",
		"Add Product": "",
		"Delivery Note Dimension Form": "",
		"Default Bin": "",
		"Upload": "",
		"Transaction Date From": "",
		"Post": "",
		"Sold Quantity": "",
		"Stock Balance": "",
		"Edit BOM Entry": "",
		"Download Template": "",
		"Numerator (Convert Rate)": "",
		"Denominator (Convert Rate)": "",
		"Pending Semi Product": "",
		"Time": "",
		"Detail": "",
		"Transfer List": "",
		"Supplier Ref No From": "",
		"Quantity (Numerator)": "",
		"Quantity (Denominator)": "",
		"Stock Shortage": "",
		"Expected Receive": "",
		"Tpl Quantity": "",
		"Tpl Wastage%": "",
		"Usage": "",
		"Actual Usage": "",
		"PO Round To": "",
		"PR Date": "",
		"Goods Delivery": "",
		"Outstanding PO": "",
		"Outstanding Stock": "",
		"Management Dashboard": "",
		"As at Date": "",
		"Income": "",
		"Daily": "",
		"POS sales amount": "",
		"Material Cost": "",
		"Stock Take not ready": "",
		"Gross Profit (Material Margin)": "",
		"Total Amount (percentage)": "",
		"Stock Value": "",
		"Total value": "",
		"Purchase Amount": "",
		"PO amount": "",
		"GRN Value": "",
		"Total GRN Value": "",
		"Predicted Cost": "",
		"Expected Sales": "",
		"Wastage / Shrinkage": "",
		"Last 7 days line chart": "",
		"Profit": "",
		"Daily Material Margin": "",
		"Week": "",
		"MTD": "",
		"Target Sales vs Actual Sales": "",
		"Target Sales": "",
		"Actual Sales": "",
		"Purchase Amount & GRN Amount": "",
		"GRN Amount": "",
		"Month Top 5 Sales Product": "",
		"Month Top 5 Supplier": "",
		"Inventory Value": "",
		"Total DN Amount": "",
		"Total PO Amount": "",
		"PO Amount By Shop": "",
		"Last 7 days PO Amount by Shop": "",
		"Fulfill Rate for Production Plan (By Product)": "",
		"Last 7 days fulfill rate": "",
		"Average Fulfill rate for shop requirement": "",
		"Average Fulfill rate for Production Plan": "",
		"Month Top 5 Product": "",
		"Save User Setting": "",
		"Workflow": "",
		"Average Require Quantity in X days": "",
		"Edit Substitute Product Details": "",
		"Purchase Order Report": "",
		"Purchase Order Product Dimension": "",
		"Customer Quotation Report": "",
		"Import Price": "",
		"Quantity Range": "",
		"Customer PO Report": "",
		"Avaliable Goods Receive Time": "",
		"Additional Information": "",
		"Stock Balance Search": "",
		"PO Quantity": "",
		"PR Confirmation Report": "",
		"Product Report": "",
		"Backlog Order Report": "",
		"Stock Take Variance Report": "",
		"Expected Delivery Date Report": "",
		"Shrinkage Reason Report": "Shrinkage Report",
		"PO Status Report": "",
		"Purchase Order Status Report": "",
		"PO Summary": "",
		"PO Summary Report": "",
		"Purchase Billing Status": "",
		"Purchase Billing Status Report": "",
		"Skip Fully Billed PO2": "",
		"Expired on or before": "",
		"Monthly Stock Quantity Balance": "",
		"Monthly Stock Quantity Balance Report": "",
		"Details of Monthly In/Out Report": "",
		"Actual Cost Report": "",
		"Actual Consumption VS Expected Consumption": "",
		"Supplier Calendar": "",
		"Year": "",
		"Rest Date": "",
		"English Description": "",
		"Chinese Description": "",
		"Location Master": "",
		"Phone No.": "",
		"Stock Recalculate": "",
		"Have Qty": "",
		"Default Home Screen": "",
		"Please confirm to copy the current record": "",
		"In Progress": "",
		"Completed": "",
		"Shop": "",
		"Management": "",
		"PO Amount (Current Month vs Last Month)": "",
		"Daily Inventory Overview": "",
		"Last Month": "",
		"Current Month": "",
		"Base Stock Qty": "",
		"Aging Days": "",
		"PR Summary": "",
		"Delivery Schedule": "",
		"Backlog": "",
		"EXP. Delivery Date Report": "",
		"Stock Quantity Balance": "",
		"Stock Value Balance": "",
		"ACT. vs EXP. Consumption": "",
		"Monthly Stock Value Balance Report": "",
		"POS": "",
		"Product Setting": "",
		"PR Round To": "",
		"Average Qty in x Days": "",
		"Abnormal Percentage": "",
		"Sale Item Mapping": "",
		"Sale Item Code": "",
		"Sale Item Description": "",
		"Now": "",
		"PO Not Confirmed": "",
		"Complete": "",
		"Calculate": "",
		"Customer Master": "",
		"Other Name": "",
		"Company": "",
		"Billing Address": "",
		"Debtor Account Code": "",
		"Global Location No.": "",
		"BR Number": "",
		"Tax": "",
		"VAT/GST Number": "",
		"Last GST Status Update Date": "",
		"Own Customer": "",
		"Company Code": "",
		"Contact": "",
		"Default Contact": "",
		"Supplier Master": "",
		"Creditor Account Code": "",
		"Approved Supplier": "",
		"Join Date": "",
		"Grading": "",
		"Grading Remark": "",
		"Price Management": "",
		"MOQ": "",
		"Stock Will Expire": "",
		"Product Will Expire": "",
		"Will Expire After": "",
		"Petty Cash Transaction": "",
		"Need Posting": "",
		"Product Related": "",
		"Expired": "",
		"Day(s)": "",
		"Change Password": "",
		"New Password": "",
		"Confirmed Password": "",
		"Record Not Found": "",
		"Goods Return": "",
		"Rating": "",
		"Comment": "",
		"Stock will Expire in _ days": "",
		"PR Quantity": "",
		"Delivery Location From": "",
		"Supplier From": "",
		"Show Zero Balance Record": "",
		"Remaining Qty": "",
		"PO Amount": "",
		"Date1 From": "",
		"Date2 From": "",
		"Date3 From": "",
		"Skip Fully Billed PO": "",
		"Aging Days 1": "",
		"Aging Days 2": "",
		"Aging Days 3": "",
		"Aging Days 4": "",
		"Aging Days 5": "",
		"Finished Good From": "",
		"Stock Ledger Detail Report": "",
		"Transaction Type From": "",
		"Display Balance B/F": "",
		"User Profile": "",
		"Access Right": "",
		"User Master": "",
		"Initial Company": "",
		"Default User Role": "",
		"Rating Master": "",
		"Rating Code": "",
		"Sale Item Template": "",
		"Quantity From": "",
		"Unit From": "",
		"Quantity To": "",
		"Unit To": "",
		"Overall": "",
		"Pending Semi-Product": "",
		"Remaining Quantity(+)": "",
		"Extra Quantity(-)": "",
		"Remaining Quantity": "",
		"Extra Quantity": "",
		"Urgent Flag": "",
		"Inventory Section": "",
		"Require Qty": "",
		"Adjust Qty": "",
		"Qty Unit": "",
		"Average Qty": "",
		"Stock Excess": "",
		"_ Day(s)": "",
		"Products (WIP)": "",
		"Stocks": "",
		"Work in progress": "",
		"Calendar": "",
		"Daily Balance": "",
		"Recipe Cost": "",
		"Inactive Item": "",
		"Details of Monthly In/Out": "",
		"Details of Monthly In/Out (Amount)": "",
		"Monthly In/Out": "",
		"PR/PO Status": "",
		"Stock Ledger Detail": "",
		"Stock Ledger Summary": "",
		"Expected Delivery Date": "",
		"Backlog Order": "",
		"Stock Take Variance": "",
		"Shrinkage Reason": "",
		"Monthly Stock Value Balance": "",
		"Actual Cost": "",
		"Delivery Schedule (By Shipping Date)": "",
		"PR Not Submitted": "",
		"DN Not Align PR": "",
		"Language": "",
		"Select Language": "",
		"Traditional Chinese": "",
		"English": "",
		"Function Name": "",
		"Edit Contact Detail": "",
		"Edit Price Detail": "",
		"Task Overview": "",
		"Copy": "",
		"Price": "",
		"Accumulated Billed Amount": "",
		"Compare": "",
		"BOM Adjust Quantity": "",
		"General Calendar": "",
		"Calendar Type": "",
		"Kiosk (Shop)": "",
		"Kiosk (ProductLine)": "",
		"Daily Balance Report": "",
		"Inactive Item Report": "",
		"Monthly In/Out Report": "",
		"Details of Monthly In/Out (Amount) Report": "",
		"Template": "",
		"Select": "",
		"New": "",
		"Edit": "",
		"Outstanding Task Overview": "",
		"Quick View": "",
		"PO Enquiry": "",
		"Lead Time": "",
		"PR Template From": "",
		"Batch Update": "",
		"Enter your email address to reset your password.": "",
		"DN Complete": "",
		"PO No/Doc No": "",
		"Supplier/Shop Location": "",
		"PO Date/Transfer Date": "",
		"Request Date": "",
		"Dashboard Template Rule": "",
		"Start Value": "",
		"End Value": "",
		"Color": "",
		"User Config": "",
		"Function URL": "",
		"Apply To": "",
		"Apply Supplier To PR Template": "",
		"Stock ID From": "",
		"Income by Shop": "",
		"Actual Cost by Shop": "",
		"Expected Sales Cost by Shop": "",
		"Purchase Amount by Shop": "",
		"Purchase Amount by Supplier": "",
		"Top 5 Product Purchase": "",
		"GRN Value by Supplier": "",
		"Top 5 Location": "",
		"Wastage Amount by Shop": "",
		"Stock Value by Shop": "",
		"Top 5 Product": "",
		"Purchase Amount by Workshop": "",
		"Stock Value by Workshop": "",
		"DN Value by Workshop": "",
		"Fulfill Rate for Product Production Plan (Last 7 days)": "",
		"Fulfill Rate for Product Production Plan (Month)": "",
		"Load Template": "",
		"Inventory is being updated. Please wait a second and try again": "",
		"Product cannot transfer more than total stock in quantity": "",
		"Product not found": "",
		"Done.": "",
		"Please select a valid date range": "",
		"Shops Not Submitted PR": "",
		"PO Generated Today": "",
		"PO Generated Yesterday": "",
		"User _ already exists in common ledger, continue to override the user name and default ledger?": "",
		"Sent PO": "",
		"No Product is needed to purchase": "",
		"Expiration Warning": "",
		"Expiration Warning Level": "",
		"Auto Allocate": "",
		"Lot Number": "",
		"Marked For Delivery": "",
		"Available Qty": "",
		"Next Day Cut Off Time": "",
		"Main Product": "",
		"PR Parameter": "",
		"Product Expired": "",
		"Product Not Expired": "",
		"Please allocate the following DN(s)": "",
		"The following DNs delivery quantity not align with the lot quantity": "",
		"Please allocate the following BOM(s)": "",
		"The following BOMs target quantity not align with the actual quantity": "",
		"Not Enough Raw Materials": "",
		"BOM Not Found": "",
		"Please allocate the following Product(s)": "",
		"The following Products target quantity not align with the actual quantity": "",
		"The following Products delivery quantity not align with the lot quantity": "",
		"Edit Layout": "",
		"Shop Product Management": "",
		"Monthly Shop Product Management": "",
		"Receive Quantity": "",
		"GRN Variance": "",
		"Verify": "",
		"Related Products": "",
		"Holiday Setup": "",
		"Order Cut Off Day": "",
		"Deliver On Holiday": "",
		"Loading": "",
		"Modify PO": "",
		"Total Receive Quantity": "",
		"Total Delivery Quantity": "",
		"Cashier": "",
		"Self-Paid": "",
		"Original Amount": "",
		"UDField1": "Lot No",
		"Unit Setting": "",
		"Shrinkage Default Unit": "",
		"Product Sorting Template": "",
		"Product Sorting": "",
		"Source": "",
		"Repeat On": "",
		"Order Date": "",
		"Can Deliver": "",
		"Shop Cut Off Time": "",
		"實際客數": "Actual",
		"予想客數": "Expected",
		"UDField2": "Batch No",
		"UDField3": "S. PKG. No.",
		"未提交請購單": "Unsubmitted PR",
		"未確認請購單": "Unconfirmed PR",
		"未完成收貨單": "Outstanding GRN",
		"工場送貨不足": "Undershipment of Goods",
		"新增請購單": "Create PR",
		"查詢請購單": "PR Enquiry",
		"收貨": "GRN",
		"入倉": "Stock In",
		"點倉": "Stock Take",
		"點倉紀錄搜尋": "Stock Take Search",
		"倉存轉移": "Stock Transfer",
		"查詢倉存轉移": "Stock Transfer Search",
		"每週銷售預測": "Weekly Sales Forecast",
		"報廢輸入": "Shrinkage Entry",
		"每日倉存一覽": "Daily Stock Balance",
		"將會過期": "Stock Will Expire",
		"將會過期貨品": "Product Will Expire",
		"剩餘保質天數": "Will Expire After",
		"零用現金": "Petty Cash Transaction",
		"是否入倉": "Need Posting",
		"貨品相關": "Product Related",
		"沒有紀錄": "Record Not Found",
		"退貨": "Goods Return",
		"福食計算": "Staff Meal",
		"主頁": "Home",
		"範本": "Template",
		"到貨日期": "Delivery Date",
		"請購單日期": "PR Date",
		"請購單": "PR",
		"貨品": "Product",
		"數量": "Quantity",
		"貨品單位": "Unit",
		"儲存": "Save",
		"提交": "Submit",
		"搜尋/新增貨品": "Search/Add Product",
		"請購單編號由": "PR No From",
		"至": "To",
		"請購日期由": "PR Date From",
		"送貨日期由": "Delivery Date From",
		"提交狀況": "Submit Status",
		"重設": "Reset",
		"搜尋": "Search",
		"系統生成": "System Generate",
		"請購單編號": "PR No",
		"請購日期": "PR Date",
		"送貨日期": "Delivery Date",
		"收貨類型": "Source Type",
		"供應商": "Supplier",
		"店鋪地址": "Shop Location",
		"採購單編號由": "PO No From",
		"採購單日期由": "PO Date From",
		"要求貨期由": "Request Date From",
		"文件編號由": "Document No From",
		"轉移日期由": "Transfer Date From",
		"收貨單": "GRN",
		"選擇採購單": "Select PO",
		"收貨查詢": "GRN Enquiry",
		"送貨狀態": "Delivery Status",
		"採購單編號/文件編號": "PO No/Document No",
		"供應商/店舖地址": "Supplier/Shop Location",
		"採購單日期/轉移日期": "PO Date/Transfer Date",
		"要求貨期": "Request Date",
		"備註": "Remark",
		"採購單編號": "PO No",
		"採購數量": "PO Qty",
		"現收數量": "Rec Qty",
		"未收數量": "OS Qty",
		"總現收數量": "Total Rec Qty",
		"供應商參考編號": "Supplier Reference No",
		"貨品備註": "Product Remark",
		"完成": "Complete",
		"收貨備註": "Remark",
		"儲存格": "Bin",
		"新增儲存格": "Add Bin",
		"刪除": "Delete",
		"保質期": "Expiry Date",
		"單位": "Unit",
		"收貨單編號由": "GRN No From",
		"發票編號由": "Supplier Invoice No From",
		"收貨單編號": "GRN No",
		"提交人": "Incharge",
		"提交日期": "Submission Date",
		"發票編號": "Supplier Invoice No",
		"點倉日期": "Stock Take Date",
		"轉移日期": "Transfer Date",
		"收貨地點": "Receive Location",
		"文件編號": "Document No",
		"預覽": "Preview",
		"生成請購單": "Generate PR",
		"預計銷售": "Expected Sales",
		"實際銷售": "Actual Sales",
		"完成品": "Finished Good",
		"原材料": "Raw Material",
		"請購數量": "PR Quantity",
		"送貨數量": "DN Quantity",
		"現收貨量": "Receive Quantity",
		"入倉數量": "Stock In Quantity",
		"送貨未完成": "Not Delivery",
		"入倉查詢": "Stock In Enquiry",
		"倉存轉移搜尋": "Stock Transfer Search",
		"店舖食材管理": "Product Line",
		"工作單": "BOM Entry",
		"確認提交?": "Are you sure to submit?",
		"確認儲存?": "Are you sure to save?",
		"價格": "Price",
		"最少採購量": "MOQ",
		"價格(單位)": "Price(Unit)",
		"價值": "Amount",
		"負責人": "Incharge",
		"今日請購紀錄": "Today Request",
		"Filter": "Filter",
		"未有選擇物品": "No item selected",
		"今日預計收貨紀錄": "Today Expected Delivery",
		"今日點倉紀錄": "Today Stock Take",
		"今日倉存轉移紀錄": "Today Stock Transfer",
		"最近5次點倉紀錄": "Last 5 Records",
		"未有盤點全部物品, 你確定要提交嗎?": "Are you sure to do partial stock take?",
		"請輸入轉移日期及收貨地點": "Please input transfer date and receive location",
		"最近": "Last",
		"紀錄": "Record(s)",
		"GRN Created": "GRN Created",
		"Stock Transfer, GRN Created": "Stock Transfer, GRN Created",
		"Confirm to delete this record ?": "Confirm to delete this record ?",
		"Done": "Done",
		"Attachments": "Attachments",
		"File Name": "File Name",
		"File Size": "File Size",
		"Mime Type": "Mime Type",
		"Create Date": "Create Date",
		"此物品已經存在": "Item already exists",
		"Cannot find Template for your current location": "Cannot find Template for your current location",
		"The Stock is enough for the expected sale, No PR will be generated": "The Stock is enough for the expected sale, No PR will be generated",
		"Password changed": "Password changed",
		"部份物品未有盤點全部庫存部份, 你確定要提交嗎?": "Some products do not stock take all inventory section, are you sure to submit?",
		"所需原材料": "Required Raw Material",
		"所有": "All",
		"確認完成": "Complete",
		"DN Not Enough": "DN Not Enough",
		"OS GRN": "OS GRN",
		"Filters": "Filters",
		"MarkComplete_Y": "Yes",
		"MarkComplete_N": "No",
		"Download Data": "",
		"With Local Data": "",
		"PR Progress": "",
		"Summary": "",
		"Recipe Calculation": "",
		"Submission Date": "",
		"Expected Date": "",
		"PR Qty": "",
		"Updated Qty": "",
		"PO Qty": "",
		"GRN Qty": "",
		"No Record": "",
		"Lot No.": "",
		"提取數量": "Pickup Quantity",
		"實際數量不能大於倉存量": "Actual Quantity cannot be greater than On-hand Balance",
		"額外數量不能大於倉存量": "Extra Quantity cannot be greater than On-hand Balance",
		"剩餘數量不能大於第一次提取數量": "Remaining Quantity cannot be greater than Pickup Quantity",
		"總剩餘數量不能大於總提取數量": "Total Remaining Quantity cannot be greater than Total Pickup Quantity",
		"Monthly Input": "",
		"Start Production": "",
		"Some shrinkage record is missing Reason": "",
		"Confirm to post the {module} on {date}": "",
		"Staff Meal": "",
		"確認清單": "Check List",
		"Some shrinkage record is missing Lot No": "",
		"Difference": "",
		"Day": "",
		"點倉(店長)": "Stock Take (Manager)",
		"點倉紀錄搜尋(店長)": "Stock Take Search (Manager)",
		"報廢輸入(店長)": "Shrinkage Entry (Manager)",
		"福食計算(店長)": "Staff Meal (Manager)",
		"Function not available in offline mode": "",
		"Stock Transfer Variance": "",
		"Transferred Quantity": "",
		"使用日期": "Date Of Use",
		"複制請購單": "Copy PR",
		"取消請購單": "Cancel PR",
		"刪除請購單": "Delete PR",
		"Offline": "",
		"Create BOM": "",
		"最大點倉數": "Max. Stock Take Quantity",
		"每週銷售預測(店長)": "Weekly Sales Forecast (Manager)",
		"New Recipe": "",
		"上次點倉日期": "Last Stock Take Date",
		"食材": "Product",
		"予想客數輸入表": "Monthly Sales Target",
		"今日收貨紀錄": "Today GRN",
		"沒有貨品, 請更改你的篩選條件": "Record Not Found, Please change your criteria",
		"期待在庫": "Expected Stock",
		"Variance": "",
		"客數": "Customer",
		"本日開始倉數": "Stock Balance",
		"收貨數量": "Good Receive",
		"倉存轉移(轉出)": "Stock Transfer(Stock Out)",
		"使用數量(POS)": "Usage (POS)",
		"報廢": "Shrinkage",
		"福食": "Staff Meal",
		"預計庫存": "Expected Stock",
		"實際庫存": "Actual Stock",
		"不明數": "Unknown Qty",
		"不明數(按客數計算)": "Unknown Qty (Per Customer)",
		"Pending for verification": "",
		"數量/金額": "Qty/Amount",
		"請先選擇供應商": "Please Select Supplier",
		"Return Date": "Return Date",
		"退回日期由": "Return Date From",
		"今日進貨退出紀錄": "Today Purchase Return",
		"Purchase Return": "Purchase Return",
		"Select All": "Select All",
		"Create": "Create",
		"Invoice No": "Invoice No",
		"Add Charge": "Add Charge",
		"Purchase Return Search": "Purchase Return Search",
		"修改收貨單": "Modify GRN",
		"確認修改收貨單?": "Confirm to modify GRN?",
		"Semi Product: Determine whether generate BOM or PR": "",
		"Balance: On-hand balance of product": "",
		"Expected Receive: The expected quantity (PR not generated PO, Not Marked PO,Oustanding GRN) to be received on a specific Delivery Date": "",
		"Pending Semi-Product: Quantity of outstanding/processing BOM": "",
		"Min Stock Level: A certain predetermined minimum quantity of product which should never drop": "",
		"BOM Reserve: Predicted quantity of raw materials used to produce": "",
		"DN Deliver: Total binding quantity to be delivered": "",
		"Weekly Forecast: Total estimated request quantity of all location on the following day": "",
		"Stock Shortage = (Balance + Expected Receive + Pending Semi-Product) - (Min Stock Level + BOM Reserve + DN Deliver + Weekly Forecast)": "",
		"PR is saved successfully": "",
		"PR is confirmed successfully": "",
		"Remain here": "",
		"Next Step": "",
		"Go back to homepage": "",
		"Please select at least one BOM": "",
		"Confirm to adjust the follwing BOM Plan Quantity ?": "",
		"Supplier Missing Line:": "",
		"Please input the currency. Line:": "",
		"The unit price of the following products is equal to ZERO. Line:": "",
		"There are products of same Supplier have different exchange rate.": "",
		"The Require Quantity of the following products is less than Minimum Order Quantity, Continue to Confirm?": "",
		"This GRN needs to verify by Procurement": "",
		"This GRN needs to verify by Transferred Shop": "",
		"The following products are allocated to deliver and cannot be updated": "",
		"The Delivery Quantity of  is not align to allocated quantity": "",
		"The Receive Quantity cannot greater than Delivery Quantity": "",
		"Supplier Invoice No./Delivery Note No. is required": "",
		"Data not saved will be lost, Confirm to continue": "",
		"Offline data is found for this GRN, Continue to overwrite offline data?": "",
		"One pending stock take record already existed": "",
		"Confirm to delete": "",
		"Confirm to cancel": "",
		"在自動分貨之前將會生成工作單, 確定要繼續嗎?": "The BOM will be saved before auto allocate, Confirm to continue?",
		"The Stock Take Quantity of following products is larger than Maximum Stock Take Quantity": "",
		"{ProductDesc} should mark as Completed": "",
		"This record is already posted, cannot save or confirm again": "",
		"Price Mode": "",
		"Sales Order History": "",
		"Customer Name": "",
		"Customer Other Name": "",
		"Reference Description": "",
		"Confirmed Quantity": "",
		"Reserved Quantity": ""
	},
	"cb5": {
		"Purchase_workshop": "叫貨",
		"Good Receive": "出貨",
		"Save Quantity": "儲存數量",
		"Home": "主頁",
		"Kiosk Home": "Kiosk主頁",
		"Purchase": "採購",
		"Supplier Price Inquiry": "供應商價格查詢",
		"PR Confirmation Search": "請購單確認搜尋",
		"PR Confirmation": "請購單確認",
		"PO Search": "採購單搜尋",
		"Purchase Order": "採購單",
		"Supplier Invoice Search": "供應商發票搜尋",
		"Supplier Invoice Entry": "供應商發票輸入",
		"Sales": "銷售",
		"Customer Quotation Search": "客戶報價單搜尋",
		"Customer Quotation Entry": "客戶報價單輸入",
		"Customer PO Search": "客戶訂單搜尋",
		"Customer PO": "客戶訂單",
		"Delivery Note Search": "送貨單搜尋",
		"Delivery Note Entry": "送貨單輸入",
		"Customer Invoice Search": "客戶發票搜尋",
		"Customer Invoice": "客戶發票",
		"Sales Return Search": "銷貨退回單搜尋",
		"Sales Return": "銷貨退回單",
		"Stock": "倉存",
		"Stock Search": "倉存搜尋",
		"Stock Take Search": "點倉紀錄搜尋",
		"Stock Take": "點倉",
		"Stock Transfer Search": "倉存轉移搜尋",
		"Stock Transfer": "倉存轉移",
		"Stock Adjustment": "倉存調整",
		"Stock Adjustment Search": "倉存調整搜尋",
		"Report": "報表",
		"Product Sales": "貨品銷量",
		"Stock Listing": "倉存列表",
		"Stock Movement": "倉存變動",
		"PO List": "採購單列表",
		"Customer Quotation List": "客戶報價單列表",
		"Customer PO List": "客戶請購單列表",
		"POS Transaction": "前台交易",
		"Stock List": "倉存列表",
		"Stock Movement List": "倉存移動列表",
		"Inventory Variation": "倉存差異列表",
		"Master": "主檔",
		"PR Template": "請購單模版",
		"BOM Search": "工作單搜尋",
		"BOM Entry": "工作單輸入",
		"BOM Entry (Shop)": "工作單輸入 (門市)",
		"BOM Template": "工作單模版",
		"Product Master": "貨品主檔",
		"Unit Master": "單位主檔",
		"User Role": "用戶角色",
		"User Location": "用戶地點",
		"Nutrition Master": "營養主檔",
		"Logout": "登出",
		"User Preference": "用戶偏好",
		"Dashboard": "儀表板",
		"Refresh Frequency": "更新頻率",
		"Refresh": "更新",
		"Location": "地點",
		"Supplier Code": "供應商編號",
		"Product Code From": "貨品編號由",
		"Stock In No.": "入倉編號",
		"Stock In No": " 入倉編號",
		"Stock In Date": "入倉日期",
		"Expiry Date": "保質期限",
		"Reset": "重設",
		"Location/Bin": "地點/儲存格",
		"Product": "貨品",
		"On-hand Balance": "倉存量",
		"Base Amount": "金額等值",
		"View Stock Details": "查閱倉存詳細",
		"Stock Ledger": "倉存出入數紀錄",
		"Doc Date": "文件日期",
		"Post Date": "發佈日期",
		"Doc No": "文件編號",
		"Stock ID": "倉存編號",
		"In/Out Qty": "出入倉數量",
		"Close": "關閉",
		"Supplier Reference No": "供應商參考編號",
		"Product Remark": "貨品備註",
		"Kiosk Home (Product Line)": "Kiosk主頁 (生產線)",
		"Login Home Page": "登入主頁",
		"LOGIN": "登入",
		"Sign In to your account": "登入至你的帳號",
		"User Name": "用戶名稱",
		"Password": "密碼",
		"Login": "登入",
		"Forgot password?": "忘記密碼?",
		"Sign Up": "註冊",
		"Register Now": "現在註冊",
		"Procurement Dashboard": "採購儀表板",
		"Supplier Price List Not Updated": "未更新供應商價格表",
		"Products": "貨品",
		"Suppliers": "供應商",
		"No. of shop Not Submitted PR": "未提交請購單分店數量",
		"No of shop Not Submitted PR": " 未提交請購單分店數量",
		"Shops": "間",
		"Department": "部門",
		"Contact Person": "聯絡人",
		"Tel. No.": "電話號碼",
		"Tel. No": " 電話號碼",
		"Abnormal Product Quantity": "異常請購數量",
		"PR No": "請購單編號",
		"Require Quantity": "需要數量",
		"Quantity Unit": "數量單位",
		"Base Unit": "基本單位",
		"Average Quantity": "平均數量",
		"Percentage": "百分比",
		"New Product Requests": "新貨品請購",
		"PR Not Confirmed": "未確認請購單",
		"Receive Date": "收到日期",
		"Batch Confirm": "批次確認",
		"Pivot Table": "樞紐分析表",
		"Total": "總數",
		"Total Amount": "總金額",
		"Template Name": "模版名稱",
		"Save as Template": "儲存為模版",
		"PR Not Generated PO": "未處理的請購單",
		"Daily Genearted PO": "每日已生成採購單",
		"Today": "今天",
		"Yesterday": "昨天",
		"Delivery Date": "送貨日期",
		"Total Amount of PO in Last 7 days": "過去7日採購單總金額",
		"Top 10 Suppliers in Last 7 days": "過去7日首10個供應商",
		"Import": "匯入",
		"Export": "匯出",
		"Workshop Dashboard": "工場儀表板",
		"Workshop Dashboard (Manager)": "工場儀表板 (經理)",
		"Not Enough Inventory": "倉存不足",
		"Semi Product": "半製成品",
		"DN Quantity": "送貨數量",
		"Product Balance": "貨品餘量",
		"Unit": "單位",
		"Generate": "生成",
		"Outstanding DN": "未完成送貨",
		"Outstanding": "未完成",
		"Posted": "已發佈",
		"Date": "日期",
		"Location Group": "地點組別",
		"All": "全部",
		"No Location Group": "沒有地點組別",
		"DN No": "送貨單編號",
		"DN Date": "實際送貨日期",
		"To Location": "收貨地點",
		"Delivery Type": "送貨類型",
		"Below Minimum Stock Level": "低於最低倉存量",
		"Min Stock Level": "最低倉存量",
		"BOM Reserve": "工作單預留",
		"DN Deliver": "待送貨數量",
		"GRN Receive": "收貨",
		"Balance": "餘量",
		"Above Maximum Stock Level": "超過最高倉存量",
		"Max Stock Level": "最高倉存量",
		"Not Match Quantity (DN & GRN)": "收貨與送貨數量不相乎",
		"Records": "紀錄",
		"DNNo": "送貨單編號",
		"GRNNo": "收貨單編號",
		"ReceQuantity": "收貨數量",
		"AdjustReceQuantity": "調整收貨數量",
		"DNQuantity": "送貨數量",
		"AdjustDNQuantity": "調整送貨數量",
		"Stock in Quantity": "門市收貨數量",
		"Adjust Stock in Quantity": "調整收貨數量",
		"Stock out Quantity": "工場送貨數量",
		"Adjust Stock out Quantity": "調整送貨數量",
		"Each PR": "按每張請購單",
		"Group PR": "組合請購單",
		"Daily Generated PO": "每日已生成採購單",
		"PO No": "採購單編號",
		"PO Date": "訂單日期",
		"Delivery Location": "送貨地點",
		"Supplier": "供應商",
		"Outstanding GRN": "未完成收貨",
		"Outstanding BOM": "未完成工作單",
		"Transaction Code": "交易編號",
		"Transaction Date": "交易日期",
		"Plan Quantity": "計劃數量",
		"Processing BOM": "處理中工作單",
		"Batch Post": "批次發佈",
		"Completed BOM": "已完成工作單",
		"Total Number of DN in Last 7 days": "過去七日內送貨單總數量",
		"Total Number and Amount of DN By Shop in Last 7 days (By Percentage)": "過去七日內各門市送貨單總數量及總金額 (按百分比)",
		"Please select": "請選擇",
		"PO Date From": "採購單日期由",
		"Request Date From": "要求貨期由",
		"Date From": "日期由",
		"Delivery Date From": "送貨日期由",
		"Supplier Invoice No. From": "發票編號由",
		"Supplier Invoice No From": " 發票編號由",
		"PO Number": "訂單號碼",
		"Search": "搜尋",
		"PO Type": "採購單類型",
		"PO Status": "採購單狀態",
		"Purchase Type": "採購類型",
		"Consignment Contract": "寄售合同",
		"Consignment Purchase": "寄售購買",
		"Normal Purchase": "正常購買",
		"Incharge": "負責人",
		"Currency": "貨幣",
		"Exchange Rate": "匯率",
		"Mark Product": "新增貨品",
		"Product Code": "產品編號",
		"Supplier Reference No.": "供應商參考編號",
		"Dimension": "細明",
		"Dimension Description": "說明",
		"Quantity": "數量",
		"Keep Inventory": "需存倉",
		"No": "否",
		"Yes": "是",
		"Unit price": "單價",
		"Discount %": "折扣%",
		"Net Unit Price": "淨單價",
		"Location Type": "地點類型",
		"Product Line": "生產線",
		"Target Date": "目標日期",
		"Search ": "搜尋",
		"Tax code": "稅務編號",
		"Amount": "金額",
		"Remark": "備註",
		"Save": "儲存",
		"Cancel": "取消",
		"Reference No.": "參考編號",
		"Reference No": " 參考編號",
		"Placing Orderd Method": "下單方法",
		"Wechat": "微信",
		"Nil": "沒有",
		"Whatsapp": "Whatsapp",
		"Payment terms": "付款條款",
		"Payment method": "付款方法",
		"80/20 80% downpayment, 20% balance": "80/20 80% 首期, 20% 尾款",
		"Contact person": "聯絡人",
		"Contact person title": "聯絡人職銜",
		"Office Phone No.": "公司電話",
		"Office Phone No": " 公司電話",
		"Mobile Phone No.": "手提電話",
		"Mobile Phone No": " 手提電話",
		"Fax": "傳真",
		"Email": "電郵",
		"Address": "地址",
		"Delivery": "送貨",
		"Contact Person Title": "聯絡人職銜",
		"Offic Phone No.": "公司電話",
		"Offic Phone No": " 公司電話",
		"Avaliable Good Receive Time": "可收貨時間",
		"Remarks": "備註",
		"Remark 1": "備註1",
		"Remark 2": "備註2",
		"Remark 3": "備註3",
		"Attachment": "附件",
		"Delivery Note": "送貨單",
		"Delivery Note No.": "送貨單編號",
		"Delivery Note No": " 送貨單編號",
		"Source Type": "來源類型",
		"Customer Order": "客戶訂單",
		"Mark Purchase Order": "標記採購單",
		"Mark Customer Order": "標記客戶訂單",
		"PO No. From": "訂單編號由",
		"PO No From": "訂單編號由",
		"Customer Code": "客戶編號",
		"Delivery Type Code": "送貨類型編號",
		"To Department": "送貨部門",
		"Delivery quantity": "送貨數量",
		"Delivery Address": "送貨地址",
		"Delivery Contact Person": "送貨聯絡人",
		"Delivery Contact Person Title": "送貨聯絡人職銜",
		"Delivery Office Phone No.": "送貨公司電話",
		"Delivery Office Phone No": " 送貨公司電話",
		"Delivery Mobile Phone No.": "送貨手提電話",
		"Delivery Mobile Phone No": " 送貨手提電話",
		"Delivery Fax": "送貨傳真",
		"Delivery Email": "送貨電郵",
		"Delivery Remark": "送貨備註",
		"Print": "列印",
		"Submit": "提交",
		"Template Code": "模版編號",
		"Delivery Time Session": "送貨時段",
		"Quanity Unit": "數量單位",
		"Default Supplier": "預設供應商",
		"Own Supplier": "自家供應商",
		"Apply Daily": "每日訂單",
		"Edit Product Details": "編輯貨品詳情",
		"Product Tag": "貨品標記",
		"Select Product Tag": "選擇貨品標記",
		"No ": "否",
		"Default Supplier Code": "預設供應商編號",
		"Save ": "儲存",
		"Delete": "刪除",
		"BOM No From": "工作單編號由",
		"BOM Date From": "工作單日期由",
		"Finished Product": "完成品",
		"Post Status": "發佈狀態",
		"Confirmed": "確認",
		"Pending": "待定",
		"BOM No": "工作單編號",
		"BOM Date": "工作單日期",
		"Type": "類型",
		"Finished Good": "完成品",
		"Bin": "儲存格",
		"BOM Dimension Form": "工作單細明",
		"Actual Quantity": "實際數量",
		"Nutrient Code": "營養編號",
		"Serving Size": "食用份量",
		"Servings Per Package": "每包裝食用份量",
		"Raw Material": "原材料",
		"Recalculate": "重新計算",
		"Wastage%": "損耗率%",
		"Cal Usage": "計算用量",
		"Edit Raw Material Detail": "編輯原材料詳情",
		"Standard Quantity": "標準數量",
		"Recipe Group": "食譜分類",
		"Major Group": "主組別",
		"Gross Weight": "淨重量",
		"Charge": "收費",
		"Active Status": "狀態",
		"Active": "可用",
		"Draft": "草稿",
		"Inactive": "停用",
		"Inventory Details": "倉存詳情",
		"Description": "說明",
		"Other Description": "其他說明",
		"Specification": "規格",
		"Barcode": "條碼",
		"Product Type": "貨品類型",
		"Product Group": "貨品組別",
		"Product Category 1": "貨品種類 1",
		"Product Category 2": "貨品種類 2",
		"Product Category 3": "貨品種類 3",
		"Product Category 4": "貨品種類 4",
		"Product Category 5": "貨品種類 5",
		"Product Group Type": "貨品組別類型",
		"Inventory": "倉存",
		"Stock Type": "倉存類型",
		"Expense": "費用",
		"Fixed Asset": "固定資產",
		"Service": "服務",
		"Costing Method": "成本計算法",
		"Keep Base Unit 2": "需要基本單位 2",
		"Expire in X days": "在X日後過期",
		"Expire Days": "過期日",
		"Minimum Stock Level": "最低倉存量",
		"Maximum Stock Level": "最高倉存量",
		"Product Price": "貨品價格",
		"Select lowest price off": "預設選擇最低價格",
		"Purchase Tax Code": "採購稅",
		"Sales Tax Code": "銷售稅",
		"Default Price": "預設價格",
		"Account Code": "會計編號",
		"Country of origin": "原產地",
		"Product Dimension": "貨品細明",
		"Description1": "說明 1",
		"Description2": "說明 2",
		"Description3": "說明 3",
		"Ingredient": "成分",
		"Origin": "來源地",
		"Ingredient Description 1": "成分説明 1",
		"Ingredient Description 2": "成分説明 2",
		"Nutrition": "營養",
		"Nutrition Information Display Format": "營養資料顯示格式",
		"Image": "圖片",
		"Unit Code": "單位編號",
		"Name": "名稱",
		"Convert Unit": "轉換單位",
		"Convert Rate": "轉換率",
		"System Admin": "系統管理員",
		"Procurement": "採購",
		"Shop Manager": "店鋪經理",
		"Workshop": "工埸",
		"User": "用戶",
		"Function Description": "功能說明",
		"BOM Entry (Product Line View)": "工作單輸入 (按生產線)",
		"Customer Quotation": "客戶報價單",
		"DN Adjust Quantity": "送貨單數量調整",
		"Kiosk (GRN & PR Application)": "Kiosk (收貨單及請購申請)",
		"OS List": "",
		"PO Generation": "採購單生成",
		"Product Master ": "貨品總檔",
		"User Code": "用戶編號",
		"User Type": "用戶類型",
		"Location Code": "地點編號",
		"Default Location": "預設地點",
		"Display Format": "顯示格式",
		"Nutrient": "營養",
		"Nutrition Group": "營養組別",
		"Sub Group": "子組別",
		"QTY": "數量",
		"% Chinese NRV per serving": "%每份量中國營養素參考值",
		"Stock Take No. From": "點倉編號由",
		"Stock Take No From": "點倉編號由",
		"Count Sheet Date From": "點倉表日期由",
		"Stock Take Date From": "點倉日期由",
		"Stock Take No.": "點倉編號",
		"Stock Take No": "點倉編號",
		"Count Sheet Date": "點倉表日期",
		"Stock Take Date": "點倉日期",
		"Export Count Sheet": "匯出點倉表",
		"Import Stock Take": "匯入點倉紀錄",
		"Count Sheet Quantity": "倉存數量",
		"Stock Take Quantity": "點倉數量",
		"PR No.": "請購單編號",
		"GRN No.": "收貨單編號",
		"GRN No": " 收貨單編號",
		"PO No.": "採購單編號",
		"Description 1": "說明 1",
		"Description 2": "說明 2",
		"Description 3": "說明 3",
		"UD Field 1": "自定義欄位1",
		"UD Field 2": "自定義欄位2",
		"UD Field 3": "自定義欄位3",
		"UD Field 4": "自定義欄位4",
		"Barcode No.": "條碼編號",
		"Barcode No": " 條碼編號",
		"Document No. From": "文件編號由",
		"Document No From": " 文件編號由",
		"From Location": "由地點",
		"Document No.": "文件編號",
		"Document No": " 文件編號",
		"Import Stock": "匯入倉存",
		"Reason": "原因",
		"From Bin": "由儲存格",
		"From PR No": "由採購單編號",
		"To Bin": "至儲存格",
		"To PR No": "至採購單編號",
		"UDField 1": "自定義欄位1",
		"UDField 2": "自定義欄位2",
		"UDField 3": "自定義欄位3",
		"UDField 4": "自定義欄位4",
		"Unit Price": "單價",
		"Gen Barcode No.": "生成條碼編號",
		"Gen Barcode No": " 生成條碼編號",
		"Stock Adjust No.": "倉存調整編號",
		"Stock Adjust No": " 倉存調整編號",
		"Transaction Type": "交易類型",
		"Reference Document No": "參考文件編號",
		"Adjustment Date": "調整日期",
		"Adjust Quantity": "調整數量",
		"Stock Adjust No. From": "倉存調整編號由",
		"Stock Adjust No From": " 倉存調整編號由",
		"Adjustment Date From": "調整日期由",
		"Start Date": "開始日期",
		"End Date": "結束日期",
		"Discount(%)": "折扣(%)",
		"PR Code From": "請購單由",
		"Receive Date From": "收到日期由",
		"Confirm Status": "確認狀態",
		"PRNo": "請購單編號",
		"PR Number": "請購單編號",
		"Have Substitution": "有代替品",
		"General": "一般",
		"PR Type": "請購類型",
		"Purpose": "目的",
		"Total Amonut": "總金額",
		"Region": "地區",
		"Title": "職銜",
		"Fax No.": "傳真號碼",
		"Fax No": " 傳真號碼",
		"Request Quantity": "請求數量",
		"PR Confirm Product Dimension Form": "明細輸入",
		"Minimum Order Quantity": "最少採購數量",
		"Supplier Reference Code": "供應商參考編號",
		"Currency Code": "貨幣編號",
		"Discount%": "折扣%",
		"Purchase Unit": "採購單位",
		"Substitution": "代替品",
		"Confirm": "確認",
		"PR No From": "請購單編號由",
		"Generate PO By": "生成採購單按",
		"Batch No": "批次號",
		"Batch No.": "批次號",
		"Supplier Address": "供應商地址",
		"Create User": "建立用戶",
		"Consignement Contract": "寄售合同",
		"Consignement Purchase": "寄售購買",
		"Exchange rate": "匯率",
		"Placing Orders Method": "下單方法",
		"Payment Terms": "付款條款",
		"Payment Method": "付款方法",
		"Available Good Receive Time": "可收貨時間",
		"Supplier Invoice ": "供應商發票",
		"Internal No From": "內部編號由",
		"Invoice No From": "發票編號由",
		"Invoice Date From": "發票日期由",
		"Receive Location": "收貨地點",
		"Internal No": "內部編號",
		"Supplier Invoice No": "供應商發票編號",
		"Supplier Invoice Date": "供應商發票日期",
		"Previous": "前一頁",
		"Next": "後一頁",
		"Page": "頁",
		"Supplier Invoice": "供應商發票",
		"Supplier Invoice No.": "供應商發票編號",
		"GRN Issued": "已出收貨單",
		"Both billing and received": "付款及收貨",
		"Billing for received item only": "已收款",
		"Receive Department": "收貨部門",
		"Supplier Ref No": "供應商參考編號",
		"Billing Type": "收款類型",
		"With Product": "貨品",
		"With Payment Method": "付款方式",
		"80/20 80% Downpayment, 20% Balance": "80/20 80% 首期, 20% 尾數",
		"Supplier Contact Person": "供應商聯絡人",
		"Supplier Contact Person Title": "供應商聯絡人職銜",
		"Supplier Office Phone No": "供應商公司電話",
		"Supplier Mobile Phone No": "供應商手提電話",
		"Supplier Fax": "供應商傳真",
		"Supplier Email": "供應商電郵",
		"Account Analysis": "會計分析",
		"Analysis Code 1": "分析編號 1",
		"AnaCode1": "分析編號 1",
		"Analysis Code 2": "分析編號 2",
		"AnaCode2": "分析編號 2",
		"Analysis Code 3": "分析編號 3",
		"AnaCode3": "分析編號 3",
		"Analysis Code 4": "分析編號 4",
		"AnaCode4": "分析編號 4",
		"Analysis Code 5": "分析編號 5",
		"AnaCode5": "分析編號 5",
		"Product Sales Search": "貨品銷量",
		"Product Group From": "貨品組別由",
		"Product Type From": "貨品類型由",
		"Location From": "地點由",
		"Supplier Code From": "供應商編號由",
		"Issue Date From": "發出日期由",
		"Product Line From": "生產線由",
		"Stock Listing Search": "倉存列表搜尋",
		"Unit of Quantity": "數量單位",
		"Period From": "時段由",
		"S. PKG No.": "倉存包裝編號",
		"S. PKG No": " 倉存包裝編號",
		"Product List": "貨品列表",
		"Product Search": "貨品搜尋",
		"Product List Report": "貨品列表",
		"PR Summary Report": "請購單列表",
		"Location Code From": "地點編號由",
		"PR/PO Status Report": "請購/採購狀態報表",
		"PRNo From": "請購單編號由",
		"To": "至",
		"PRDate From": "請購日期由",
		"Delivery Schedule (By Shipping Date) Report": "送貨日程表 (按送貨日期)",
		"Supplier Ref. No. From": "供應商參考編號由",
		"Supplier Ref. No From": " 供應商參考編號由",
		"Complete Status": "完成狀態",
		"Transfer Search": "轉移搜尋",
		"Stock Transfer Report": "倉存轉移列表",
		"Transfer Date From": "轉移日期由",
		"Stock Balance Report": "倉存餘量報表",
		"Detail Balance Report": "詳細倉存餘量報表",
		"Detail Balance": "倉存餘量詳細",
		"Monthly In Out Report": "每月倉存進出報表",
		"Period": "月份",
		"Monthly In Out": "每月倉存進出",
		"Stock Aging Report": "庫齡報表",
		"Cut Off Date": "截至日期",
		"Stock Aging": "庫齡",
		"Stock Movement Search": "倉存移動搜尋",
		"Doc No.": "文件編號",
		"Stock Movement Report": "倉存移動報表",
		"GRN Status": "收貨狀態",
		"GRN Status Report": "收貨狀態報表",
		"GRN No. From": "收貨單編號由",
		"GRN No From": " 收貨單編號由",
		"GRN Date From": "收貨日期由",
		"Recipe Cost Report": "銷售成本報表",
		"BOM Cost Report": "加工成本報表",
		"Quotation No. From": "報價單編號由",
		"Quotation No From": " 報價單編號由",
		"Quotation Date From": "報價單日期由",
		"Quotation No.": "報價單編號",
		"Quotation No": " 報價單編號",
		"Quotation Date": "報價單日期",
		"Default Values": "預設值",
		"Lead Time (Days)": "交付周期(日)",
		"Default Lead Time": "預設交付周期",
		"Default Discount %": "預設折扣%",
		"Price Unit": "價格單位",
		"Customer": "客戶",
		"Customer Address": "客戶地址",
		"Customer Purchase Order": "客戶訂單",
		"Mark Quotation": "標記報價單",
		"Mark Customer Quotation": "標記客戶報價單",
		"PO Status ": "訂單狀態",
		"Customer Reference No.": "客戶參考編號",
		"Customer Reference No": " 客戶參考編號",
		"Customer Purchase Order Product Dimension": "組合輸入",
		"Discount Percentage": "折扣率",
		"Customer Price Inquiry": "客戶價格查詢",
		"Tax Code": "稅務編號",
		"Remark ": "備註",
		"Delivery Note No. From": "送貨單編號由",
		"Delivery Note No From": " 送貨單編號由",
		"DN Date From": "實際送貨日期由",
		"Status": "狀態",
		"Reference No. From": "參考編號由",
		"Reference No From": " 參考編號由",
		"Delivery Quantity": "送貨數量",
		"Invoice No. From": "發票編號由",
		"Customer Invoice No": "客戶發票編號",
		"Customer Invoice Date": "客戶發票日期",
		"Customer Invoice No.": "客戶發票編號",
		"DN Issued": "已出送貨單",
		"Both Billing and delivery": "收款及送貨",
		"Consignment invoice": "寄售發票",
		"Billing for delivered item only": "只對已送貨品收款",
		"Mark Delivery Note": "標記送貨單",
		"DN No From": "送貨單編號由",
		"Delivery Department": "送貨部門",
		"Customer Ref No.": "客戶參考編號",
		"Customer Ref No": " 客戶參考編號",
		"Customer Contact Person": "客戶聯絡人",
		"Customer Contact Person Title": "客戶聯絡人職銜",
		"Customer Office Phone No.": "客戶公司電話",
		"Customer Office Phone No": " 客戶公司電話",
		"Customer Mobile Phone No.": "客戶手提電話",
		"Customer Mobile Phone No": " 客戶手提電話",
		"Customer Fax": "客戶傳真",
		"Customer Email": "客戶電郵",
		"Analysis Code 1 ": "分析編號 1",
		"Sales Return No. From": "銷貨退回單編號由",
		"Sales Return No From": " 銷貨退回單編號由",
		"SR Date From": "銷貨退回單日期由",
		"Sales Return No.": "銷貨退回單編號",
		"Sales Return No": " 銷貨退回單編號",
		"Customer Ref. No.": "客戶參考編號",
		"Customer Ref. No": " 客戶參考編號",
		"Weekly Forecast": "每週銷量預測",
		"Sunday": "週日",
		"Monday": "週一",
		"Tuesday": "週二",
		"Wednesday": "週三",
		"Thursday": "週四",
		"Friday": "週五",
		"Saturday": "週六",
		"Shrinkage": "報廢",
		"Shrinkage List": "報廢列表",
		"Shrinkage Form": "損失表格",
		"Balance B/F": "昨日倉存餘量",
		"Expect Inventory": "預期倉存",
		"Wastage": "浪費數量",
		"Product Line Dashboard": "生產線儀表板",
		"Target Quantity": "目標數量",
		"Stock Inquiry": "倉存查詢",
		"Stock Report": "倉存報表",
		"Generate Data Grid": "生成數據表格",
		"Generate Report": "生成報表",
		"Add Product": "新增貨品",
		"Delivery Note Dimension Form": "送貨貨品細明",
		"Default Bin": "預設儲存格",
		"Upload": "上載",
		"Transaction Date From": "交易日期由",
		"Post": "發佈",
		"Sold Quantity": "已售數量",
		"Stock Balance": "倉存餘量",
		"Edit BOM Entry": "編輯工作單",
		"Download Template": "下載範本",
		"Numerator (Convert Rate)": "轉換單位分子",
		"Denominator (Convert Rate)": "轉換單位分母",
		"Pending Semi Product": "將收半製成品",
		"Time": "時間",
		"Detail": "詳情",
		"Transfer List": "倉存轉移列表",
		"Supplier Ref No From": "供應商參考編號由",
		"Quantity (Numerator)": "數量(分子)",
		"Quantity (Denominator)": "數量(分母)",
		"Stock Shortage": "欠倉數",
		"Expected Receive": "預計收貨",
		"Tpl Quantity": "數量",
		"Tpl Wastage%": "損耗率%",
		"Usage": "用量",
		"Actual Usage": "實際用量",
		"PO Round To": "採購進位",
		"PR Date": "請購日期",
		"Goods Delivery": "發貨",
		"Outstanding PO": "已買未收",
		"Outstanding Stock": "欠倉數",
		"Management Dashboard": "管理層儀表板",
		"As at Date": "截至日期",
		"Income": "收入",
		"Daily": "每日",
		"POS sales amount": "銷售金額",
		"Material Cost": "貨品成本",
		"Stock Take not ready": "未點倉",
		"Gross Profit (Material Margin)": "毛利(食材)",
		"Total Amount (percentage)": "總金額(百分比%)",
		"Stock Value": "倉值",
		"Total value": "總值",
		"Purchase Amount": "採購量",
		"PO amount": "採購單金額",
		"GRN Value": "收貨量",
		"Total GRN Value": "收貨單總金額",
		"Predicted Cost": "預計成本",
		"Expected Sales": "予想客數",
		"Wastage / Shrinkage": "損耗/報廢",
		"Last 7 days line chart": "過去7日概況",
		"Profit": "利潤",
		"Daily Material Margin": "每日毛利(食材)",
		"Week": "週",
		"MTD": "月",
		"Target Sales vs Actual Sales": "銷售目標與實際銷售比較",
		"Target Sales": "銷售目標",
		"Actual Sales": "實際客數",
		"Purchase Amount & GRN Amount": "採購量與收貨量比較",
		"GRN Amount": "收貨量",
		"Month Top 5 Sales Product": "每月首五銷售產品",
		"Month Top 5 Supplier": "每月首五供應商",
		"Inventory Value": "存貨價值",
		"Total DN Amount": "送貨總金額",
		"Total PO Amount": "採購總金額",
		"PO Amount By Shop": "各分店採購金額",
		"Last 7 days PO Amount by Shop": "過去7日各分店採購金額",
		"Fulfill Rate for Production Plan (By Product)": "生產計劃(食材)實行率",
		"Last 7 days fulfill rate": "過去7日實行率",
		"Average Fulfill rate for shop requirement": "分店需求平均實行率",
		"Average Fulfill rate for Production Plan": "生產計劃平均實行率",
		"Month Top 5 Product": "每月首五貨品",
		"Save User Setting": "儲存用戶設定",
		"Workflow": "流程",
		"Average Require Quantity in X days": "過去X日平均請求數量",
		"Edit Substitute Product Details": "編輯代替品詳情",
		"Purchase Order Report": "採購單報表",
		"Purchase Order Product Dimension": "採購貨品細明",
		"Customer Quotation Report": "客戶報價",
		"Import Price": "匯入價錢",
		"Quantity Range": "數量範圍",
		"Customer PO Report": "客戶訂單",
		"Avaliable Goods Receive Time": "可收貨時間",
		"Additional Information": "附加資料",
		"Stock Balance Search": "倉存餘量搜尋",
		"PO Quantity": "採購數量",
		"PR Confirmation Report": "請購確認列表",
		"Product Report": "貨品列表",
		"Backlog Order Report": "積壓訂單",
		"Stock Take Variance Report": "點倉差異",
		"Expected Delivery Date Report": "預期送貨日期",
		"Shrinkage Reason Report": "報廢報表",
		"PO Status Report": "採購單狀態",
		"Purchase Order Status Report": "採購單狀態",
		"PO Summary": "採購單摘要",
		"PO Summary Report": "採購單摘要報表",
		"Purchase Billing Status": "採購單結算狀態",
		"Purchase Billing Status Report": "採購單結算狀態報表",
		"Skip Fully Billed PO2": "省略已全數結算帳單",
		"Expired on or before": "此日或之前過期",
		"Monthly Stock Quantity Balance": "每月倉存餘量",
		"Monthly Stock Quantity Balance Report": "每月倉存餘量報表",
		"Details of Monthly In/Out Report": "每月倉存進出詳細報表",
		"Actual Cost Report": "實際成本",
		"Actual Consumption VS Expected Consumption": "實際用量與預計用量比較",
		"Supplier Calendar": "供應商假期",
		"Year": "年份",
		"Rest Date": "休息日期",
		"English Description": "英文詳情",
		"Chinese Description": "中文詳情",
		"Location Master": "地點主檔",
		"Phone No.": "電話號碼",
		"Phone No": "電話號碼",
		"Stock Recalculate": "重計倉值",
		"Have Qty": "已入數量",
		"Default Home Screen": "預設主頁",
		"Please confirm to copy the current record": "確認複製紀錄",
		"In Progress": "處理中",
		"Completed": "完成",
		"Shop": "分店",
		"Management": "管理",
		"PO Amount (Current Month vs Last Month)": "採購金額(上月與今月對比)",
		"Daily Inventory Overview": "每日倉存一覽",
		"Last Month": "上月",
		"Current Month": "今月",
		"Base Stock Qty": "出入倉數量",
		"Aging Days": "庫齡天數",
		"PR Summary": "請購單摘要",
		"Delivery Schedule": "送貨日程表",
		"Backlog": "積壓訂單",
		"EXP. Delivery Date Report": "預期送貨日期",
		"Stock Quantity Balance": "每月倉存餘量",
		"Stock Value Balance": "每月倉值餘額",
		"ACT. vs EXP. Consumption": "實際用量與預計用量比較",
		"Monthly Stock Value Balance Report": "每月倉值餘額報表",
		"POS": "前台交易數據",
		"Product Setting": "貨品設定",
		"PR Round To": "請購進位",
		"Average Qty in x Days": "X日內平均採購量",
		"Abnormal Percentage": "異常百分比",
		"Sale Item Mapping": "銷售貨品配對",
		"Sale Item Code": "銷售貨品編號",
		"Sale Item Description": "銷售貨品描述",
		"Now": "今日",
		"PO Not Confirmed": "未確認採購單",
		"Complete": "已完成",
		"Calculate": "計算",
		"Customer Master": "客戶總檔",
		"Other Name": "其他名稱",
		"Company": "公司",
		"Billing Address": "賬單地址",
		"Debtor Account Code": "債務人帳戶號碼",
		"Global Location No.": "全球位置號碼",
		"Global Location No": "全球位置號碼",
		"BR Number": "商業登記號碼",
		"Tax": "稅務",
		"VAT/GST Number": "增值稅/聯邦稅號碼",
		"Last GST Status Update Date": "聯邦稅狀況最後更新日期",
		"Own Customer": "自家客戶",
		"Company Code": "公司編號",
		"Contact": "聯絡人",
		"Default Contact": "預設聯絡人",
		"Supplier Master": "供應商總檔",
		"Creditor Account Code": "債權人帳戶號碼",
		"Approved Supplier": "已批核供應商",
		"Join Date": "加入日期",
		"Grading": "等級",
		"Grading Remark": "等級備註",
		"Price Management": "價格管理",
		"MOQ": "最少採購量",
		"Stock Will Expire": "將會過期",
		"Product Will Expire": "將會過期貨品",
		"Will Expire After": "剩餘保質天數",
		"Petty Cash Transaction": "零用現金",
		"Need Posting": "是否入倉",
		"Product Related": "貨品相關",
		"Expired": "已過期",
		"Day(s)": "日",
		"Change Password": "更改密碼",
		"New Password": "新密碼",
		"Confirmed Password": "確認密碼",
		"Record Not Found": "沒有紀錄",
		"Goods Return": "退貨",
		"Rating": "評級",
		"Comment": "意見",
		"Stock will Expire in _ days": "_日後過期貨品",
		"PR Quantity": "請購數量",
		"Delivery Location From": "送貨地點由",
		"Supplier From": "供應商由",
		"Show Zero Balance Record": "包括零倉存",
		"Remaining Qty": "剩餘數量",
		"PO Amount": "採購單金額",
		"Date1 From": "日期1由",
		"Date2 From": "日期2由",
		"Date3 From": "日期3由",
		"Skip Fully Billed PO": "忽略已收齊供應商發票的採購單",
		"Aging Days 1": "庫齡日期1",
		"Aging Days 2": "庫齡日期2",
		"Aging Days 3": "庫齡日期3",
		"Aging Days 4": "庫齡日期4",
		"Aging Days 5": "庫齡日期5",
		"Finished Good From": "完成品由",
		"Stock Ledger Detail Report": "倉存流水賬詳細報表",
		"Transaction Type From": "交易類型由",
		"Display Balance B/F": "包括昨日倉存餘量",
		"User Profile": "用戶設定檔",
		"Access Right": "使用權限",
		"User Master": "用戶主檔",
		"Initial Company": "公司",
		"Default User Role": "預設用戶角色",
		"Rating Master": "評級主檔",
		"Rating Code": "評級編號",
		"Sale Item Template": "銷售貨品模版",
		"Quantity From": "數量由",
		"Unit From": "單位由",
		"Quantity To": "數量至",
		"Unit To": "單位至",
		"Overall": "全部",
		"Pending Semi-Product": "將收半製成品",
		"Remaining Quantity(+)": "剩餘數量(+)",
		"Extra Quantity(-)": "額外數量(-)",
		"Remaining Quantity": "剩餘數量",
		"Extra Quantity": "額外數量",
		"Urgent Flag": "是否緊急",
		"Inventory Section": "倉存部分",
		"Require Qty": "需要數量",
		"Adjust Qty": "調整數量",
		"Qty Unit": "數量單位",
		"Average Qty": "平均數量",
		"Stock Excess": "超出倉數",
		"_ Day(s)": "_ 日",
		"Products (WIP)": "貨品 (工作進行中)",
		"Stocks": "倉存",
		"Work in progress": "工作進行中",
		"Calendar": "月曆",
		"Daily Balance": "每日倉存餘量",
		"Recipe Cost": "銷售成本",
		"Inactive Item": "待用貨品",
		"Details of Monthly In/Out": "每月倉存進出詳細",
		"Details of Monthly In/Out (Amount)": "每月倉存進出詳細(金額)",
		"Monthly In/Out": "每月倉存進出",
		"PR/PO Status": "請購/採購狀態",
		"Stock Ledger Detail": "倉存流水賬詳細",
		"Stock Ledger Summary": "倉存流水賬摘要",
		"Expected Delivery Date": "預期送貨日期",
		"Backlog Order": "積壓訂單",
		"Stock Take Variance": "點倉差異",
		"Shrinkage Reason": "報廢原因",
		"Monthly Stock Value Balance": "每月倉值餘額",
		"Actual Cost": "實際成本",
		"Delivery Schedule (By Shipping Date)": "送貨日程表 (按送貨日期)",
		"PR Not Submitted": "未提交請購單",
		"DN Not Align PR": "工場送貨不足",
		"Language": "語言",
		"Select Language": "選擇語言",
		"Traditional Chinese": "繁體中文",
		"English": "英文",
		"Function Name": "功能名稱",
		"Edit Contact Detail": "編輯聯絡人詳情",
		"Edit Price Detail": "編輯價格詳情",
		"Task Overview": "儀表板一覽",
		"Copy": "複製",
		"Price": "價格",
		"Accumulated Billed Amount": "已付款金額",
		"Compare": "比較",
		"BOM Adjust Quantity": "工作單數量調整",
		"General Calendar": "月曆",
		"Calendar Type": "月曆類型",
		"Kiosk (Shop)": "Kiosk (分店)",
		"Kiosk (ProductLine)": "Kiosk (生產線)",
		"Daily Balance Report": "每日倉存餘量報表",
		"Inactive Item Report": "待用貨品報表",
		"Monthly In/Out Report": "每月倉存進出報表",
		"Details of Monthly In/Out (Amount) Report": "每月倉存進出詳細(金額)報表",
		"Template": "模版",
		"Select": "選擇",
		"New": "新增",
		"Edit": "編輯",
		"Outstanding Task Overview": "儀表板一覽",
		"Quick View": "快速預覽",
		"PO Enquiry": "查詢採購單",
		"Lead Time": "交付周期",
		"PR Template From": "請購單模版由",
		"Batch Update": "批次更新",
		"Enter your email address to reset your password.": "請輸入你的電郵地址。",
		"DN Complete": "送貨完成",
		"PO No/Doc No": "採購單編號/文件編號",
		"Supplier/Shop Location": "供應商/店鋪地址",
		"PO Date/Transfer Date": "採購單日期/轉移日期",
		"Request Date": "要求貨期",
		"Dashboard Template Rule": "儀表板模版規定",
		"Start Value": "起始值",
		"End Value": "結束值",
		"Color": "顏色",
		"User Config": "用戶配置檔",
		"Function URL": "功能網址",
		"Apply To": "應用於",
		"Apply Supplier To PR Template": "應用於請購單模版",
		"Stock ID From": "倉存編號由",
		"Income by Shop": "各分店收入",
		"Actual Cost by Shop": "各分店貨品成本",
		"Expected Sales Cost by Shop": "各分店預計成本",
		"Purchase Amount by Shop": "各分店採購量",
		"Purchase Amount by Supplier": "各供應商採購量",
		"Top 5 Product Purchase": "首五採購貨品",
		"GRN Value by Supplier": "各供應商收貨量",
		"Top 5 Location": "首五分店",
		"Wastage Amount by Shop": "各分店浪費金額",
		"Stock Value by Shop": "各分店倉值",
		"Top 5 Product": "首五貨品",
		"Purchase Amount by Workshop": "各工場採購量",
		"Stock Value by Workshop": "各工場倉值",
		"DN Value by Workshop": "各工場送貨量",
		"Fulfill Rate for Product Production Plan (Last 7 days)": "食材生產計劃實行率 (過去7日)",
		"Fulfill Rate for Product Production Plan (Month)": "食材生產計劃實行率 (本月)",
		"Load Template": "載入模版",
		"Inventory is being updated. Please wait a second and try again": "倉存更新中，請您稍等片刻",
		"Product cannot transfer more than total stock in quantity": "不能轉移多於收貨總數量",
		"Product not found": "找不到貨品",
		"Done.": "完成",
		"Please select a valid date range": "請選擇有效的日期範圍",
		"Shops Not Submitted PR": "未提交請購單分店",
		"PO Generated Today": "今日生成採購單",
		"PO Generated Yesterday": "昨日生成採購單",
		"User _ already exists in common ledger, continue to override the user name and default ledger?": "用戶 _ 已存在, 要繼續並複寫用戶名稱及預設帳本?",
		"Sent PO": "已發出採購單",
		"No Product is needed to purchase": "不需購買任何貨品",
		"Expiration Warning": "到期預警",
		"Expiration Warning Level": "到期預警設定",
		"Auto Allocate": "自動分貨",
		"Lot Number": "批次號",
		"Marked For Delivery": "已標記送貨數量",
		"Available Qty": "可分貨數量",
		"Next Day Cut Off Time": "下日截數時間",
		"Main Product": "主要貨品",
		"PR Parameter": "必要系數",
		"Product Expired": "已過期貨品",
		"Product Not Expired": "未過期貨品",
		"Please allocate the following DN(s)": "以下送貨單未完成分貨",
		"The following DNs delivery quantity not align with the lot quantity": "以下送貨單的送貨數量與批次數量不一致",
		"Please allocate the following BOM(s)": "以下工作單未完成分貨",
		"The following BOMs target quantity not align with the actual quantity": "以下工作單的目標數量與實際數量不一致",
		"Not Enough Raw Materials": "原材料不足",
		"BOM Not Found": "找不到工作單",
		"Please allocate the following Product(s)": "以下貨品未完成分貨",
		"The following Products target quantity not align with the actual quantity": "以下貨品的目標數量與實際數量不一致",
		"The following Products delivery quantity not align with the lot quantity": "以下貨品的送貨數量與批次數量不一致",
		"Edit Layout": "編輯布局",
		"Shop Product Management": "店鋪用全食材管理表(按日)",
		"Monthly Shop Product Management": "店鋪用食材管理表(按月)",
		"Receive Quantity": "收貨數量",
		"GRN Variance": "收貨差異",
		"Verify": "核對",
		"Related Products": "相關貨物",
		"Holiday Setup": "假期設定",
		"Order Cut Off Day": "截單日數",
		"Deliver On Holiday": "於假期提供運貨",
		"Loading": "載入中",
		"Modify PO": "修改採購單",
		"Total Receive Quantity": "總收貨數量",
		"Total Delivery Quantity": "總送貨數量",
		"Cashier": "收銀機",
		"Self-Paid": "自費",
		"Original Amount": "開倉倉值",
		"UDField1": "批次號",
		"Unit Setting": "單位設定",
		"Shrinkage Default Unit": "報廢預設單位",
		"Product Sorting Template": "貨品排序模版",
		"Product Sorting": "貨品排序",
		"Source": "來源",
		"Repeat On": "重複星期",
		"Order Date": "下單日期",
		"Can Deliver": "提供運貨",
		"Shop Cut Off Time": "店鋪截數時間",
		"實際客數": "實際客數",
		"予想客數": "予想客數",
		"UDField2": "批次號",
		"UDField3": "S. PKG. No.",
		"未提交請購單": "未提交請購單",
		"未確認請購單": "未確認請購單",
		"未完成收貨單": "未完成收貨單",
		"工場送貨不足": "工場送貨不足",
		"新增請購單": "新增請購單",
		"查詢請購單": "查詢請購單",
		"收貨": "收貨",
		"入倉": "入倉",
		"點倉": "點倉",
		"點倉紀錄搜尋": "點倉紀錄搜尋",
		"倉存轉移": "倉存轉移",
		"查詢倉存轉移": "查詢倉存轉移",
		"每週銷售預測": "每週銷售預測",
		"報廢輸入": "報廢輸入",
		"每日倉存一覽": "每日倉存一覽",
		"將會過期": "將會過期",
		"將會過期貨品": "將會過期貨品",
		"剩餘保質天數": "剩餘保質天數",
		"零用現金": "零用現金",
		"是否入倉": "是否入倉",
		"貨品相關": "貨品相關",
		"沒有紀錄": "沒有紀錄",
		"退貨": "退貨",
		"福食計算": "福食計算",
		"主頁": "主頁",
		"範本": "範本",
		"到貨日期": "到貨日期",
		"請購單日期": "請購單日期",
		"請購單": "請購單",
		"貨品": "貨品",
		"數量": "數量",
		"貨品單位": "貨品單位",
		"儲存": "儲存",
		"提交": "提交",
		"搜尋/新增貨品": "搜尋/新增貨品",
		"請購單編號由": "請購單編號由",
		"至": "至",
		"請購日期由": "請購日期由",
		"送貨日期由": "送貨日期由",
		"提交狀況": "提交狀況",
		"重設": "重設",
		"搜尋": "搜尋",
		"系統生成": "系統生成",
		"請購單編號": "請購單編號",
		"請購日期": "請購日期",
		"送貨日期": "送貨日期",
		"收貨類型": "收貨類型",
		"供應商": "供應商",
		"店鋪地址": "店鋪地址",
		"採購單編號由": "採購單編號由",
		"採購單日期由": "採購單日期由",
		"要求貨期由": "要求貨期由",
		"文件編號由": "文件編號由",
		"轉移日期由": "轉移日期由",
		"收貨單": "收貨單",
		"選擇採購單": "選擇採購單",
		"收貨查詢": "收貨查詢",
		"送貨狀態": "送貨狀態",
		"採購單編號/文件編號": "採購單編號/文件編號",
		"供應商/店舖地址": "供應商/店舖地址",
		"採購單日期/轉移日期": "採購單日期/轉移日期",
		"要求貨期": "要求貨期",
		"備註": "備註",
		"採購單編號": "採購單編號",
		"採購數量": "採購數量",
		"現收數量": "現收數量",
		"未收數量": "未收數量",
		"總現收數量": "總現收數量",
		"供應商參考編號": "供應商參考編號",
		"貨品備註": "貨品備註",
		"完成": "完成",
		"收貨備註": "收貨備註",
		"儲存格": "儲存格",
		"新增儲存格": "新增儲存格",
		"刪除": "刪除",
		"保質期": "保質期",
		"單位": "單位",
		"收貨單編號由": "收貨單編號由",
		"發票編號由": "發票編號由",
		"收貨單編號": "收貨單編號",
		"提交人": "提交人",
		"提交日期": "提交日期",
		"發票編號": "發票編號",
		"點倉日期": "點倉日期",
		"轉移日期": "轉移日期",
		"收貨地點": "收貨地點",
		"文件編號": "文件編號",
		"預覽": "預覽",
		"生成請購單": "生成請購單",
		"預計銷售": "預計銷售",
		"實際銷售": "實際銷售",
		"完成品": "完成品",
		"原材料": "原材料",
		"請購數量": "請購數量",
		"送貨數量": "送貨數量",
		"現收貨量": "現收貨量",
		"入倉數量": "入倉數量",
		"送貨未完成": "送貨未完成",
		"入倉查詢": "入倉查詢",
		"倉存轉移搜尋": "倉存轉移搜尋",
		"店舖食材管理": "店舖食材管理",
		"工作單": "工作單",
		"確認提交?": "確認提交?",
		"確認儲存?": "確認儲存?",
		"價格": "價格",
		"最少採購量": "最少採購量",
		"價格(單位)": "價格(單位)",
		"價值": "價值",
		"負責人": "負責人",
		"今日請購紀錄": "今日請購紀錄",
		"Filter": "篩選",
		"未有選擇物品": "未有選擇物品",
		"今日預計收貨紀錄": "今日預計收貨紀錄",
		"今日點倉紀錄": "今日點倉紀錄",
		"今日倉存轉移紀錄": "今日倉存轉移紀錄",
		"最近5次點倉紀錄": "最近5次點倉紀錄",
		"未有盤點全部物品, 你確定要提交嗎?": "未有盤點全部物品, 你確定要提交嗎?",
		"請輸入轉移日期及收貨地點": "請輸入轉移日期及收貨地點",
		"最近": "最近",
		"紀錄": "紀錄",
		"GRN Created": "已建立收貨單",
		"Stock Transfer, GRN Created": "倉存轉移, 已建立收貨單",
		"Confirm to delete this record ?": "確認刪除此紀錄?",
		"Done": "完成",
		"Attachments": "附件",
		"File Name": "檔案名稱",
		"File Size": "檔案大小",
		"Mime Type": "媒體類型",
		"Create Date": "建立日期",
		"此物品已經存在": "此物品已經存在",
		"Cannot find Template for your current location": "找不到可用的範本",
		"The Stock is enough for the expected sale, No PR will be generated": "倉存已足夠應付預計銷售, 並不會再生成請購單",
		"Password changed": "密碼已更改",
		"部份物品未有盤點全部庫存部份, 你確定要提交嗎?": "部份物品未有盤點全部庫存部份, 你確定要提交嗎?",
		"所需原材料": "所需原材料",
		"所有": "所有",
		"確認完成": "確認完成",
		"DN Not Enough": "工場送貨不足",
		"OS GRN": "未完成收貨單",
		"Filters": "篩選",
		"MarkComplete_Y": "完成",
		"MarkComplete_N": "未完成",
		"Download Data": "下載離線數據",
		"With Local Data": "離線數據",
		"PR Progress": "請購進度表",
		"Summary": "總結",
		"Recipe Calculation": "食譜計算",
		"Submission Date": "提交日期",
		"Expected Date": "預期送貨日期",
		"PR Qty": "請購數量",
		"Updated Qty": "數量",
		"PO Qty": "採購數量",
		"GRN Qty": "收貨數量",
		"No Record": "沒有紀錄",
		"Lot No.": "批次號",
		"Lot No": "批次號",
		"提取數量": "提取數量",
		"實際數量不能大於倉存量": "實際數量不能大於倉存量",
		"額外數量不能大於倉存量": "額外數量不能大於倉存量",
		"剩餘數量不能大於第一次提取數量": "剩餘數量不能大於第一次提取數量",
		"總剩餘數量不能大於總提取數量": "總剩餘數量不能大於總提取數量",
		"Monthly Input": "予想客數輸入表",
		"Start Production": "開始製作",
		"Some shrinkage record is missing Reason": "部份報廢紀錄沒有輸入原因",
		"Confirm to post the {module} on {date}": "確認提交 {date}  的{module}紀錄?",
		"Staff Meal": "福食",
		"確認清單": "確認清單",
		"Some shrinkage record is missing Lot No": "部份報廢紀錄沒有輸入批次號",
		"Difference": "相差數",
		"Day": "星期",
		"點倉(店長)": "點倉(店長)",
		"點倉紀錄搜尋(店長)": "點倉紀錄搜尋(店長)",
		"報廢輸入(店長)": "報廢輸入(店長)",
		"福食計算(店長)": "福食計算(店長)",
		"Function not available in offline mode": "離線狀態不能使用此功能",
		"Stock Transfer Variance": "倉存轉移差異",
		"Transferred Quantity": "轉移數量",
		"使用日期": "使用日期",
		"複制請購單": "複制請購單",
		"取消請購單": "取消請購單",
		"刪除請購單": "刪除請購單",
		"Offline": "離線",
		"Create BOM": "新增工作單",
		"最大點倉數": "最大點倉數",
		"每週銷售預測(店長)": "每週銷售預測(店長)",
		"New Recipe": "按食譜新增",
		"上次點倉日期": "上次點倉日期",
		"食材": "食材",
		"予想客數輸入表": "予想客數輸入表",
		"今日收貨紀錄": "今日收貨紀錄",
		"沒有貨品, 請更改你的篩選條件": "沒有貨品, 請更改你的篩選條件",
		"期待在庫": "期待在庫",
		"Variance": "差異",
		"客數": "客數",
		"本日開始倉數": "本日開始倉數",
		"收貨數量": "收貨數量",
		"倉存轉移(轉出)": "倉存轉移(轉出)",
		"使用數量(POS)": "使用數量(POS)",
		"報廢": "報廢",
		"福食": "福食",
		"預計庫存": "預計庫存",
		"實際庫存": "實際庫存",
		"不明數": "不明數",
		"不明數(按客數計算)": "不明數(按客數計算)",
		"Pending for verification": "等待批核",
		"數量/金額": "數量/金額",
		"請先選擇供應商": "請先選擇供應商",
		"Return Date": "退回日期",
		"退回日期由": "退回日期由",
		"今日進貨退出紀錄": "今日進貨退出紀錄",
		"Purchase Return": "進貨退出",
		"Select All": "全選",
		"Create": "新增",
		"Invoice No": "發票編號",
		"Add Charge": "加收費用",
		"Purchase Return Search": "進貨退出搜尋",
		"修改收貨單": "修改收貨單",
		"確認修改收貨單?": "確認修改收貨單?",
		"Semi Product: Determine whether generate BOM or PR": "半製成品: 用於決定生成工作單或採購單",
		"Balance: On-hand balance of product": "餘量: 現有倉存量",
		"Expected Receive: The expected quantity (PR not generated PO, Not Marked PO,Oustanding GRN) to be received on a specific Delivery Date": "預計收貨: 在指定送貨日期的預計收貨量（未生成採購單的請購單、 未確認採購單及未完成收貨單）",
		"Pending Semi-Product: Quantity of outstanding/processing BOM": "將收半製成品: 未完成/處理中的半製成品",
		"Min Stock Level: A certain predetermined minimum quantity of product which should never drop": "最低倉存量: 確保生產所需原材料倉存數量的最低界限",
		"BOM Reserve: Predicted quantity of raw materials used to produce": "工作單預留: 預計生產所需原材料數量",
		"DN Deliver: Total binding quantity to be delivered": "待送貨數量: 將要送貨數量",
		"Weekly Forecast: Total estimated request quantity of all location on the following day": "每週銷量預測: 預測所有店鋪的請求數量（取決於明日預計銷量、供應商假期及店鋪倉存量）",
		"Stock Shortage = (Balance + Expected Receive + Pending Semi-Product) - (Min Stock Level + BOM Reserve + DN Deliver + Weekly Forecast)": "欠倉數 = （餘量 + 預計收貨 + 將收半製成品）-（最低倉存量 + 工作單預留 + 待送貨數量 + 每週銷量預測）",
		"PR is saved successfully": "請購單儲存成功",
		"PR is confirmed successfully": "請購單確認成功",
		"Remain here": "停留在此頁面",
		"Next Step": "下一步",
		"Go back to homepage": "返回主頁面",
		"Please select at least one BOM": "請選擇工作單",
		"Confirm to adjust the follwing BOM Plan Quantity ?": "確認更改工作單數量?",
		"Supplier Missing Line:": "以下行數沒有供應商:",
		"Please input the currency. Line:": "以下行數沒有貨幣:",
		"The unit price of the following products is equal to ZERO. Line:": "以下行數價錢為0:",
		"There are products of same Supplier have different exchange rate.": "發現兩個兌換利率",
		"The Require Quantity of the following products is less than Minimum Order Quantity, Continue to Confirm?": "下列物品的需求數量低於最少採購數量, 確認要繼續?",
		"This GRN needs to verify by Procurement": "此收貨單需要採購部批核",
		"This GRN needs to verify by Transferred Shop": "此收貨單要由轉移貨品的店鋪確認",
		"The following products are allocated to deliver and cannot be updated": "以下貨品已經分配發貨, 因此未能更新",
		"The Delivery Quantity of  is not align to allocated quantity": "送貨數量與分配數量不相乎",
		"The Receive Quantity cannot greater than Delivery Quantity": "收貨數不能大於送貨數",
		"Supplier Invoice No./Delivery Note No. is required": "供應商發票/送貨單號必須輸入",
		"Supplier Invoice No/Delivery Note No is required": "供應商發票/送貨單號必須輸入",
		"Data not saved will be lost, Confirm to continue": "未儲存的資料將會失去, 確定要繼續",
		"Offline data is found for this GRN, Continue to overwrite offline data?": "已找到有此收貨單的離線資料, 確認覆寫?",
		"One pending stock take record already existed": "已存在未確認點倉紀錄",
		"Confirm to delete": "確定要刪除",
		"Confirm to cancel": "確定要取消",
		"在自動分貨之前將會生成工作單, 確定要繼續嗎?": "在自動分貨之前將會生成工作單, 確定要繼續嗎?",
		"The Stock Take Quantity of following products is larger than Maximum Stock Take Quantity": "以下貨品的點倉數量大於最大可點倉數",
		"{ProductDesc} should mark as Completed": "{ProductDesc} 應標記為已完成",
		"This record is already posted, cannot save or confirm again": "此紀錄已經確認, 不能再次儲存或提交",
		"Price Mode": "貨品",
		"Sales Order History": "客戶訂單紀錄",
		"Customer Name": "客戶名稱",
		"Customer Other Name": "",
		"Reference Description": "參考",
		"Confirmed Quantity": "已確認數量",
		"Reserved Quantity": "已預訂數量"
	}
}



// WEBPACK FOOTER //
// ./src/language.js